import { http } from "../utils/http.js";
const stewardshipEndpoint = 'stewardship';
/**
 * Reupload locally pinned data
 * @param ky Ky instance
 * @param reference
 * @param options
 * @throws BeeResponseError if not locally pinned or invalid data
 */

export async function reupload(ky, reference) {
  await http(ky, {
    method: 'put',
    path: `${stewardshipEndpoint}/${reference}`
  });
}
export async function isRetrievable(ky, reference) {
  const response = await http(ky, {
    method: 'get',
    responseType: 'json',
    path: `${stewardshipEndpoint}/${reference}`
  });
  return response.data.isRetrievable;
}